const getEmbedResourcePath = (args) => {
  switch (args.type) {
    case "folder":
      return `/folders/${args.resourceId}`;
    case "space":
      return `/spaces/${args.resourceId}`;
    default:
      return window.location.pathname + `?expandedFdocId=${args.resourceId}`;
  }
};

export { getEmbedResourcePath };
//# sourceMappingURL=utils.js.map
